import { useFormatter, useNow } from "use-intl";

export function useAgoFormatter(created: Date | string) {
  const format = useFormatter();
  const now = useNow({
    updateInterval: 1000 * 10,
  });

  return format.relativeTime(
    typeof created === "string" ? new Date(created) : created,
    now,
  );
}
